import type { GridOptions } from '../../../components/ui/table';
import { commonGridOptions } from '../../../lib/agGridOptions';
import {
  GRID_PAGE_SIZE,
  GRID_PAGE_SIZE_SELECTOR,
} from '../../../components/shared/agGridCells';
import type { UserGridRow } from './columnDefs';

export { GRID_PAGE_SIZE, GRID_PAGE_SIZE_SELECTOR };

export const userGridOptionsBase = {
  ...commonGridOptions,
  overlayNoRowsTemplate:
    '<span class="text-sm text-muted-foreground">No users match the current filters.</span>',
  suppressRowClickSelection: true,
} satisfies GridOptions<UserGridRow>;
